import React, { useMemo } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { useCustomersChasablesApi } from "../../../../hooks/useCustomersChasablesApi";

type Props = {
  currencyFilter: string[];
  onCurrencyFilterChange(currencyFilter: string[]): void;
};

export function CurrencyFilter({ currencyFilter, onCurrencyFilterChange }: Props) {
  const { chasables: apiChasables } = useCustomersChasablesApi();

  const currencyOptions = useMemo(() => {
    const set = new Set<string>();
    for (const c of apiChasables) {
      for (const inv of c.invoices) {
        if (inv.currency) set.add(inv.currency);
      }
    }
    return Array.from(set).sort();
  }, [apiChasables]);

  const selectedOptions = currencyOptions.filter((c) => currencyFilter.includes(c));

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      size="small"
      options={currencyOptions}
      value={selectedOptions}
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(a, b) => a === b}
      onChange={(_, value) => onCurrencyFilterChange(value)}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option}
            label={option}
            size="small"
            sx={{ zIndex: 1000, fontSize: 12 }}
          />
        ))
      }
      renderInput={(params) => <TextField {...params} label="Currency" placeholder="All currencies" />}
      sx={{ minWidth: 200, "& .MuiAutocomplete-clearIndicator svg": { width: "15px", height: "15px" } }}
    />
  );
}
